import * as Survey from "survey-react";
import { enableNextButton, focusAndClearInputs } from "./utils";
export default function onValueChanged(survey, options) {
  // only for current page
  if (!options.question.page.hasShownValue) {
    return;
  }

  // add a11y attr to close button
  if (options.question.customWidgetValue?.name === "tagbox") {
    const tags = document.querySelectorAll(
      '.select2-selection__choice__remove[role="presentation"]'
    );

    if (!!tags.length) {
      tags.forEach((tag) => {
        tag.setAttribute("role", "button");
        tag.setAttribute("tabindex", "0");
        tag.setAttribute("aria-label", `${tag.parentElement.title} remove`);
        /*
        tag.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L10 4.76837e-07L6 4L2 0L4.76838e-07 2L4 6L0 10L2 12L6 8L10 12L12 10L8 6L12 2Z" fill="#10181F"/>
        </svg>`;
        */
      });
    }
  }

  // remove aria-label if something is selected
  if (options.question.customWidgetValue?.name === "select2") {
    const select2Textbox = document.querySelector(
      ".select2-selection__rendered[title]"
    );
    if (select2Textbox) {
      select2Textbox.removeAttribute("aria-label");
    }
  }

  // remove all aria-invalid from radio\
  let elementRadio = document.getElementsByClassName(
    "sv_q_radiogroup_control_item"
  );

  for (let i = 0; i < elementRadio.length; i++) {
    elementRadio[i].removeAttribute("aria-invalid");
  }

  // enable "Next" button if question is answered
  enableNextButton(
    options.value !== "" &&
      !options.question.containsErrors &&
      options.question.isAnswered
  );

  if (options.question instanceof Survey.QuestionTextModel) {
    if (options.question.value === null) {
      document
        .querySelector(`#${options.question.inputId}`)
        ?.classList.remove("filled-in");
    }
  }

  // if radiogroup/checkbox and "other" value selected
  // - focus the textarea
  if (
    (options.question instanceof Survey.QuestionRadiogroupModel ||
      options.question instanceof Survey.QuestionCheckboxModel) &&
    (options.value === "other" || options.value?.indexOf("other") !== -1)
  ) {
    // skip the "other" input
    setTimeout(function () {
      const otherInput = document.querySelector(".sv_q_other");
      if (otherInput) {
        //const otherVal = otherInput.value;
        otherInput.focus();
        focusAndClearInputs(document, survey);
      }
    }, 10);
  }

  if (options.question instanceof Survey.QuestionCheckboxModel) {
    const group = document.querySelector("[role='group']");
    if (group) {
      group.removeAttribute("aria-invalid");
      group.removeAttribute("aria-required");
    }
  }
}
